// extracted by mini-css-extract-plugin
export var link = "link-button-module--link--l2nDX";